export function formatThousandSeparator(price: number): string {
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function formatDollar(price: number, currency: string): string {
  return `(${currency}${formatThousandSeparator(price)}.00)`;
}
